/*!
  Brava, by Koding Themes
  theme-mode.js
  https://kodingthemes.com
*/

(function() {
  var listenersAttached = false;

  document.addEventListener("DOMContentLoaded", function() {
    initThemeMode();
  });
  document.addEventListener("shopify:section:load", function() {
    initThemeMode();
  });

  function initThemeMode() {
    var body = document.body;
    var themeStyleBtns = document.querySelectorAll(".light-mode");
    var themeLabel = document.querySelector(".theme-mode-label .mode-button-text");
    var themeIcons = document.querySelector(".theme-mode-icons");
    var defaultText = document.querySelector('.mode-button-text');

    if (defaultText) {
      defaultText.classList.add('d-none');
    }
    if (themeIcons) {
      themeIcons.classList.remove('d-none');
      themeIcons.classList.add('d-block');
    }

    // always set initial state so attribute is present
    applyMode(body, themeLabel);

    if (!listenersAttached) {
      listenersAttached = true;

      // delegate click for toggle buttons
      document.addEventListener('click', function(e) {
        if (e.target.closest('.light-mode')) {
          if (localStorage.lightMode === "dark") {
            localStorage.lightMode = "light";
          } else {
            localStorage.lightMode = "dark";
          }
          applyMode(document.body, document.querySelector(".theme-mode-label .mode-button-text"));
        }
      });

      // sync across tabs
      window.addEventListener("storage", function() {
        applyMode(document.body, document.querySelector(".theme-mode-label .mode-button-text"));
      });
    }
  }

  function applyMode(body, themeLabel) {
    var hasToggle = document.querySelectorAll(".light-mode").length > 0;
    var isDark = hasToggle && localStorage.lightMode === "dark";
    body.setAttribute("light-mode", isDark ? "dark" : "light");
    if (window.theme) {
      if (themeLabel) {
        themeLabel.textContent = isDark ? window.theme.darkMode : window.theme.lightMode;
      }
      var modeLabels = document.querySelectorAll('.theme-mode-label span:not(.mode-light-icon):not(.mode-dark-icon)');
      modeLabels.forEach(function(label) {
        if (!label.closest('.theme-mode-icons')) {
          label.textContent = isDark ? window.theme.lightMode : window.theme.darkMode;
        }
      });
    }
  }
})();
